// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.PlaidIncomeVerificationWebhookStatus

export enum PlaidIncomeVerificationWebhookStatus {
  LINK_STARTED = 'LINK_STARTED',
  REPORT_FAILED = 'REPORT_FAILED',
  REPORT_IN_PROGRESS = 'REPORT_IN_PROGRESS',
  REPORT_READY = 'REPORT_READY',
  REPORT_TIMED_OUT = 'REPORT_TIMED_OUT',
}

export const PlaidIncomeVerificationWebhookStatus_values = [
  PlaidIncomeVerificationWebhookStatus.LINK_STARTED,
  PlaidIncomeVerificationWebhookStatus.REPORT_FAILED,
  PlaidIncomeVerificationWebhookStatus.REPORT_IN_PROGRESS,
  PlaidIncomeVerificationWebhookStatus.REPORT_READY,
  PlaidIncomeVerificationWebhookStatus.REPORT_TIMED_OUT,
] as const;
